/* eslint-disable */
export default {
  doNotCall: 'Niet bellen',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
